import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, DriverPayments } from '@/models/DriverPayment.model';

// Inital state
const state: DriverPayments = {
  pendingPayments: [],
  approvedPayments: [],
}

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, DriverPayments> = {
  pendingPayments: (state) => state.pendingPayments,
  approvedPayments: (state) => state.approvedPayments,
}

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, DriverPayments> = {
  setPendingPayments(state, { payments }) {
    state.pendingPayments = payments;
  },

  setApprovedPayments(state, { payments }) {
    state.approvedPayments = payments;
  },
}

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, DriverPayments, Mutations, Getters> = {
  setPendingPayments({ commit }, payload) {
    commit('setPendingPayments', payload);
  },

  setApprovedPayments({ commit }, payload) {
    commit('setApprovedPayments', payload);
  },
}

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<DriverPayments, Getters, Mutations, Actions>('DriverPaymentsModule');

export const DriverPaymentsModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};